import { ConnectionStatus, Network } from '@capacitor/network';
import { Logger } from './Logger';
import { State } from '@meraki-internal/state';

export class NetworkAdapter extends State<{connected?: boolean}> {
    static inject = () => [Logger];
    constructor(private logger: Logger) {
        super({});
    }

    startListening = async () => {

        const updateStatus = (status: ConnectionStatus) => {
            // to avoid circular dependency, we are setting a public property
            // to not send errors to sentry, that are likely a result of the
            // fact that we're offline
            this.logger.skipSendingToSentry = !status.connected;

            this.logger.info('network change', status);
            this.setState({ connected: status.connected });
        };

        // get the current network status and then listen for changes
        await Network.getStatus().then(updateStatus);
        Network.addListener('networkStatusChange', updateStatus);
    };

    public get isOnline (): boolean {
        if (this.state.connected === undefined) {
            throw new Error('Unknown network status');
        }
        return this.state.connected;
    };
}
